import { PropsWithChildren } from "react";
import { FinancialDocumentFilters } from "@common/schemas/financialDocument/financial-document-query.schema";
import { FinancialDocumentView } from "@common/types/views/financialDocumentViews";
import { FinancialDocumentBulkActionsProvider } from "@components/documents/FinancialDocumentBulkActions/FinancialDocumentBulkActionsProvider";
import { FinancialDocumentBulkSelectionContextProvider } from "@components/documents/FinancialDocumentBulkSelection/FinancialDocumentBulkSelectionContextProvider";
import { FinancialDocumentsBulkTaskViewContext } from "@components/documents/FinancialDocumentsBulkTaskView.context";

interface Props {
    view: FinancialDocumentView;
    queryFilters: FinancialDocumentFilters | null;
    total: number;
}

export const FinancialDocumentsTaskTableProvider = ({
    view,
    queryFilters,
    total,
    children,
}: PropsWithChildren<Props>) => (
    <FinancialDocumentBulkSelectionContextProvider
        // Select all must cover exactly the rows this table lists.
        currentFilters={queryFilters ?? {}}
        totalCount={total}
    >
        <FinancialDocumentsBulkTaskViewContext.Provider value={view}>
            <FinancialDocumentBulkActionsProvider>
                {children}
            </FinancialDocumentBulkActionsProvider>
        </FinancialDocumentsBulkTaskViewContext.Provider>
    </FinancialDocumentBulkSelectionContextProvider>
);
